import { render, staticRenderFns } from "./InventarioMaterial.vue?vue&type=template&id=069fcc11&"
import script from "./InventarioMaterial.vue?vue&type=script&lang=js&"
export * from "./InventarioMaterial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports